import { nodeListToArray, nodeMatches } from '../../utils'
import { parseImgProps } from '../img'
import { ArticleGallery } from '../../../components/molecule/ArticleContent/entry'
import { getAlignmentProps } from '../_utils'
import { h } from '../../parser/utils'

import { parseCaption } from './image'

export const NAME = 'block-gallery'

export const COMPONENTS = {
  ArticleGallery,
}

export function matches(node) {
  return nodeMatches(node, '.wp-block-gallery')
}

function querySelectorAllFiltered(item, selector = 'a', filterSelector = 'figcaption a') {
  return nodeListToArray(item.querySelectorAll(selector))
    .filter(a => !a.matches(filterSelector))
}

export async function transform (node, next, ctx) {
  const items = node.querySelectorAll('.blocks-gallery-item')

  const caption = await parseCaption(
    node.querySelector('.blocks-gallery-caption'),
    next,
    ctx,
  )

  let hasLink = false

  const captionPromises = []

  const entries = nodeListToArray(items).map((item, idx) => {
    captionPromises[idx] = parseCaption(
      item.querySelector('.blocks-gallery-item__caption'),
      next,
      ctx,
    )

    hasLink = hasLink || querySelectorAllFiltered(
      item,
      'a',
      'figcaption a',
    ).length !== 0

    const picture = parseImgProps(
      querySelectorAllFiltered(item, 'img', 'figcaption img').pop(),
      ctx,
      ['id', 'class', 'data-link', 'data-full-url'],
    )

    return { picture }
  })

  const captions = await Promise.all(captionPromises)

  entries.forEach((entry, idx) => {
    entry.caption = captions[idx]?.length ? captions[idx] : undefined
  })

  const props = {
    ...getAlignmentProps(node),
    boxed: {
      padded: true,
      withBackground: true,
    },
    lightbox: hasLink,
    caption: caption.length ? caption : undefined,
    entries,
  }

  return h(ArticleGallery, props)
}
